import React, { useEffect, useState } from 'react';

import { Form } from 'antd';
import { AxiosResponse } from 'axios';
import { getCheckoutPharmacies } from 'services/api';
import CheckoutCard, {
  SelectorIconEnum,
} from 'src/components/experienceCheckout/CheckoutCard';
import SelectorWrapper from 'src/components/general/ScrollableSelector';
import { getUserPharmacy } from 'src/components/pharmacy/Pharmacy.helpers';
import PharmacySelector from 'src/components/pharmacy/PharmacySelector';
import { IEditPharmacy, IUser } from 'src/shared/models';
import { capitalizeFirstLetter, customFormatMessage } from 'utils';

interface OwnProps {
  pharmacy: any;
  selectedPharmacy?: number | string;
  setPharmacy: any;
  user: IUser;
  idChallenge: number;
}

export default function CheckoutPharmacySelector({
  pharmacy,
  setPharmacy,
  user,
  idChallenge,
}: OwnProps) {
  const [showSelector, setShowSelector] = useState(false);
  const [pharmaciesCombo, setPharmaciesCombo] = useState<IEditPharmacy[]>([]);
  const [pharmaciesComboFiltered, setPharmaciesComboFiltered] = useState<
    IEditPharmacy[]
  >([]);

  const [zipCode, setZipCode] = useState<string>(null);

  const [form] = Form.useForm();

  useEffect(() => {
    async function initializeData() {
      try {
        const userPharmacy = await getUserPharmacy({ user });
        if (!userPharmacy) return;

        setZipCode(userPharmacy.zipcode);
        const pharmacyList: AxiosResponse<IEditPharmacy[]> =
          await getCheckoutPharmacies(idChallenge, userPharmacy.zipcode);

        const isPharmacyInCheckout = pharmacyList?.data?.find(
          ({ id }) => id === user.salesforce.sapCustomerId
        );
        if (isPharmacyInCheckout) {
          setPharmacy(isPharmacyInCheckout);
        } else {
          setPharmaciesCombo(pharmacyList?.data);
        }
      } catch (err) {
        console.error(err);
      }
    }

    if (!user?.salesforce?.sapCustomerId) return;

    initializeData();
  }, []);

  const pharmacyModal = showSelector && (
    <PharmacySelector
      checkout={true}
      form={form}
      handleClose={() => setShowSelector(false)}
      idChallenge={idChallenge}
      pharmaciesCombo={pharmaciesCombo}
      pharmaciesComboFiltered={pharmaciesComboFiltered}
      pharmacySelected={pharmacy}
      setPharmaciesCombo={setPharmaciesCombo}
      setPharmaciesComboFiltered={setPharmaciesComboFiltered}
      setPharmacySelected={setPharmacy}
      setZipCode={setZipCode}
      zipCode={zipCode}
      goBackHeader
    />
  );

  const renderElement = (record: IEditPharmacy) => {
    const { id, street, streetNumber, regionName, zipcode, city } = record;
    const handleAction = () => {
      setPharmacy(record);
    };

    return (
      <CheckoutCard
        action={handleAction}
        description={customFormatMessage(
          'page.experience.checkout.card-content',
          {
            address: `${street} ${streetNumber}`,
            regionName: capitalizeFirstLetter(regionName),
            zipCode: zipcode,
            city: capitalizeFirstLetter(city),
          }
        )}
        icon={SelectorIconEnum.ADDRESS}
        id={id}
        key={id}
        selected
        title={capitalizeFirstLetter(record.accountName)}
      />
    );
  };

  const extraElement = () => {
    const action = () => {
      setShowSelector(true);
    };

    return (
      <CheckoutCard
        action={action}
        icon={SelectorIconEnum.MORE}
        id="extra-selector"
        key="extra-selector"
        selected={false}
        title={customFormatMessage(
          'page.experience.checkout.pharmacy-select-other'
        )}
      />
    );
  };

  return (
    <SelectorWrapper
      data={pharmacy ? [pharmacy] : []}
      extraElement={extraElement}
      render={renderElement}
    >
      {pharmacyModal}
    </SelectorWrapper>
  );
}
